import { apiSlice } from "../app/api/apiSlice";

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getAllUsers: builder.query({
      query: (id_season) => ({
        url: `/users/get-all/${id_season}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError
        }, 
      }),
      providesTags: ['User', 'Inscription']
    }), 
    getAllPrevUsers: builder.query({
      query: (id_season) => ({
        url: `/users/get-prev-all/${id_season}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError
        }, 
      }),
      providesTags: ['User', 'Inscription']
    }), 
    getAllUsersForPresence: builder.query({
      query: (id_season) => ({
        url: `/users/all-users-for-presence/${id_season}`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError
        }, 
      }),
      providesTags: ['User', 'Inscription']
    }), 
    updateUserSeasonLicence: builder.mutation({
      query: ({ id_user_season, season_licence }) => ({
        url: `/users/users-seasons/${id_user_season}/licence`,
        method: 'PUT',
        body: { season_licence },
      }),
      invalidatesTags: ['User'],
    }),
    getAllPresences: builder.query({
      query: () => ({
        url: `/users/all-presences`,
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError
        }, 
      }),
      providesTags: ['User', 'Inscription']
    }), 
    getUserFullPresence: builder.query({
      query: ({ id_season, date_from, date_to, id_group }) => ({
        url: `/users/get-user-full-presence`,
        params: { id_season, date_from, date_to, id_group },
        validateStatus: (response, result) => response.status === 200 && !result.isError,
      }),
      providesTags: ['User', 'Inscription', 'Presence']
    }),
    upsertPresence: builder.mutation({
      query: data => ({
          url: `/users/upsert-presence`,
          method: 'POST',
          body: {
              ...data,
          }
      }),
      invalidatesTags: ['User', 'Inscription']
    }),
    insertGuestUser: builder.mutation({
      query: data => ({
          url: `/users/insert-guest-user`,
          method: 'POST',
          body: {
              ...data,
          }
      }),
      invalidatesTags: ['User', 'Inscription']
    }),
    updateUserSeasonGroup: builder.mutation({
      query: data => ({
          url: `/users/update-user-season-group`,
          method: 'PUT',
          body: {
              ...data,
          }
      }),
      invalidatesTags: ['User', 'Inscription']
    }),
    updateReviewReason: builder.mutation({
      query: data => ({
          url: `/users/update-user-season-reviews`,
          method: 'PUT',
          body: {
              ...data,
          }
      }),
      invalidatesTags: ['User', 'Inscription']
    }),
  })
})


export const { 
  useGetAllUsersQuery, useGetAllPrevUsersQuery, useGetAllUsersForPresenceQuery, useGetAllPresencesQuery, 
  useUpsertPresenceMutation, useInsertGuestUserMutation, useUpdateUserSeasonGroupMutation, 
  useGetUserFullPresenceQuery, useUpdateUserSeasonLicenceMutation, useUpdateReviewReasonMutation
} = userApiSlice